export const titles = {
  TITLE_HOME: 'Yet Another Tuner',
  TITLE_ADITIONAL_FUNCTIONS: 'Additional functions'
}

export const footer = {
  CONTACT: 'Contact',
  TERMS: 'Privacy Policy'
}

export const contact = {
  NAME: 'Name',
  EMAIL: 'Email',
  MESSAGE: 'Message',
  BUTTON: 'Send'
}


export const aditionalFunctions = [
  {
    IMAGE: require('./assets/playla.png'),
    FUNCTION: "Play the defined \"A\"."
  },
  {
    IMAGE: require('./assets/getla.png'),
    FUNCTION: "Get the \"A\" that you play in your instrument."
  },
  {
    IMAGE: require('./assets/upla.png'),
    FUNCTION: "Increase the frequency of the \"A\". (*)"
  },
  {
    IMAGE: require('./assets/dnla.png'),
    FUNCTION: "Decrease the frequency of the \"A\". (*)"
  },
  {
    IMAGE: require('./assets/defla.png'),
    FUNCTION: "Reset \"A\" with the \"Initial\" frequency defined in Preferences. (*)"
  },
  {
    IMAGE: require('./assets/preferences.png'),
    FUNCTION: "Preferences, define YAT parameters. (*)"
  },
  {
    IMAGE: require('./assets/help.png'),
    FUNCTION: "Help."
  },
  {
    FUNCTION: "(*) Premium function."
  }
]

export const characteristics = [
  {
    DESCRIPTION: "Just use YAT, the simplest chromatic tuner app, to visual tune instruments and voices using the built-in mic in your mobile device."
  },
  {
    DESCRIPTION: "Also includes a function to play an audible \"A\" as reference for tuning by ear."
  },
  {
    DESCRIPTION: "You can configure the desired frequency of the \"A\" or can play (or sing) it and YAT will adopt it as the \"A\" frequency."
  },
  {
    DESCRIPTION: "Select the ruler to savarts (default), cents o commas."
  },
  {
    DESCRIPTION: "Choose how many semitones to show on screen."
  },
  {
    DESCRIPTION: "You can download and enjoy it for free or buy to unlock premium functions."
  },
  {
    DESCRIPTION: "Compatible with Android devices (iOS coming soon)."
  }
]